import React from 'react';
import ReactDOM  from 'react-dom';
import App from './App';
import './CSS/index.scss';

ReactDOM.render(
    <React.Fragment>
        <App />
    </React.Fragment>,
    document.getElementById('root')
);